export default "__VITE_ASSET__fUv_3rgM__"